import * as tslib_1 from "tslib";
import { LazyGetter } from 'typescript-lazy-get-decorator';
import { addToStringTag } from '../util/addToStringTag';
/** @internal */
var CachedItemImpl = (function () {
    function CachedItemImpl(data, expiryTime) {
        this.data = data;
        this.expires = new Date(typeof expiryTime === 'number' ? expiryTime : 0);
    }
    Object.defineProperty(CachedItemImpl.prototype, "expired", {
        get: function () {
            return this.expiresIn === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CachedItemImpl.prototype, "expiresIn", {
        get: function () {
            return Math.max(0, this.expires.getTime() - Date.now());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CachedItemImpl.prototype, "hasData", {
        get: function () {
            return this.data !== null;
        },
        enumerable: true,
        configurable: true
    });
    CachedItemImpl.prototype.toJSON = function () {
        return {
            data: this.data,
            expired: this.expired,
            expires: this.expires,
            expiresIn: this.expiresIn,
            hasData: this.hasData
        };
    };
    tslib_1.__decorate([
        LazyGetter(),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [])
    ], CachedItemImpl.prototype, "expired", null);
    tslib_1.__decorate([
        LazyGetter(),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [])
    ], CachedItemImpl.prototype, "expiresIn", null);
    tslib_1.__decorate([
        LazyGetter(),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [])
    ], CachedItemImpl.prototype, "hasData", null);
    return CachedItemImpl;
}());
export { CachedItemImpl };
addToStringTag(CachedItemImpl, 'CachedItem');



//////////////////
// WEBPACK FOOTER
// ./src/NgForage/cache/CachedItemImpl.ts
// module id = 12
// module chunks = 0 1